import { Model } from './model';

export class Alphabet extends Model {
  constructor(public arabicBased: string, public englishBased: string) {
    super();
  }
}
